<template>
  <footer class="main-footer d-flex p-2 px-3 bg-white border-top">
    <div :class="[contained ? 'container' : 'container-fluid footer-text']">
      <div class="row">
        <span class="copyright ml-auto my-auto mr-2">{{ copyright }}</span>
      </div>
    </div>
  </footer>
</template>

<script>
const defaultMenuItems = [{
    title: 'Home',
    to: '#',
}, {
    title: 'Services',
    to: '#',
}, {
    title: 'About',
    to: '#',
}, {
    title: 'Products',
    to: '#',
}, {
    title: 'Blog',
    to: '#',
}];

export default {
    name: 'main-footer',
    props: {
    /**
       * The footer menu items.
       */
        menuItems: {
            type: Array,
            default() {
                return defaultMenuItems;
            },
        },
        /**
       * The copyright information.
       */
        copyright: {
            type: String,
            default: 'COPYRIGHT © IVANHOE.IO. All rights reserved | Ivanhoe.io B.V. | Oostergracht 13-15 | 3763LX | SOEST | The Netherlands | 035-6568113 | support@ivanhoe.io',
        },
        /**
       * Whether the footer should be wrapped in a container, or not.
       */
        contained: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
